import React, { createContext, useContext } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

// Referencia estable: si este array se recrea en cada render, @react-google-maps/api
// interpreta que las opciones de carga cambiaron y puede reintentar/advertir sobre
// una doble inclusión del script de Maps.
export const MAPS_LIBRARIES = ['places'];

const GoogleMapsContext = createContext({ isLoaded: false, loadError: undefined });

// Único punto de carga del SDK de Google Maps para toda la app.
// Antes existían 6 puntos independientes (LoadScript/useJsApiLoader/script manual)
// con distintas configuraciones de `libraries`, lo que arriesgaba cargas duplicadas
// y fallos silenciosos de Autocomplete al navegar entre pantallas de la SPA.
export function GoogleMapsProvider({ children }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'point-google-maps',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_KEY || '',
    libraries: MAPS_LIBRARIES,
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

export function useGoogleMaps() {
  return useContext(GoogleMapsContext);
}
